/**
 * Centralized logging utility that respects NODE_ENV
 * Only logs in development mode to avoid performance impact in production
 */

const IS_DEV = process.env.NODE_ENV === 'development';

/**
 * Log debug information (only in development)
 */
export function logDebug(...args) {
	if (IS_DEV) {
		console.log(...args);
	}
}

/**
 * Log warnings (always logged, but can be filtered by log level)
 */
export function logWarn(...args) {
	if (IS_DEV) {
		console.warn(...args);
	}
}

/**
 * Log errors (always logged)
 */
export function logError(...args) {
	console.error(...args);
}

/**
 * Logger object with common methods
 */
export const logger = {
	debug: logDebug,
	warn: logWarn,
	error: logError,
	info: logDebug, // info is same as debug (dev only)
};

/**
 * Create a scoped logger with a prefix
 * @param {string} scope - The scope/prefix for log messages
 * @returns {object} Logger instance with scope prefix
 */
export function createLogger(scope) {
	return {
		debug: (...args) => logDebug(`[${scope}]`, ...args),
		warn: (...args) => logWarn(`[${scope}]`, ...args),
		error: (...args) => logError(`[${scope}]`, ...args),
		info: (...args) => logDebug(`[${scope}]`, ...args),
	};
}
